import { api } from '.';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const obterContadores = async (seqUsuario: number) => {
  try {
    const response = await api.get(`/contadores/${seqUsuario}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter contadores';
    throw new Error(errorMessage);
  }
};
